import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import { theme } from "../../utils/theme";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";

function Noti() {
  const location = useLocation();
  const navigate = useNavigate();

  const { count_noti } = useSelector(
    (state: RootState) => state.listNotification
  );

  const handleClick = (event: any) => {
    navigate("/notifications");
  };

  return (
    <Box
      sx={{
        color:
          location.pathname === "/notifications"
            ? "#007F18"
            : ` ${theme.palette.text.body}`,
        position: "relative",
      }}>
      {count_noti > 0 && (
        <Box
          sx={{
            minWidth: { xs: 15, sm: 18 },
            height: { xs: 15, sm: 18 },
            px: { xs: 0.375, sm: 0.5 },
            backgroundColor: "red",
            position: "absolute",
            right: { xs: -1, sm: 0 },
            top: { xs: -2, sm: -4 },
            borderRadius: 999,
            color: "white",
            fontSize: { xs: 9, sm: 10 },
            fontWeight: 600,
            lineHeight: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          {count_noti}
        </Box>
      )}
      <NotificationsOutlinedIcon
        onClick={handleClick}
        sx={{
          cursor: "pointer",
          /* Khớp cart (26) / menu (~24) trên xs — 38px trông quá to */
          fontSize: { xs: 26, sm: 30, md: 38 },
          width: { xs: 26, sm: 30, md: 38 },
          height: { xs: 26, sm: 30, md: 38 },
        }}
      />
    </Box>
  );
}

export default Noti;
